export default {
    it: {
        "title": "I tuoi dati",
        "first_name": "Nome",
        "last_name": "Cognome",
        "email": "Email",
        "telefon": "Telefono fisso",
        "mobile": "Cellulare",
        "job": "Occupazione",
        "piva": "Partita IVA",
        "codfisc": "Codice fiscale",
        "birthplace": "Luogo di nascita",
        "birthday": "Data di nascita"

    },
    en: {
        "title": "Your infos",
        "first_name": "Name",
        "last_name": "Surname",
        "email": "Email",
        "telefon": "Telefono fisso",
        "mobile": "Mobile",
        "job": "Job",
        "piva": "VAT number",
        "codfisc": "Tax ID code",
        "birthplace": "Birthplace",
        "birthday": "Birthday"
    }
}